// extracted by mini-css-extract-plugin
module.exports = {"UpdatePage":"UpdatePage_UpdatePage__1XMcv","spindindust":"UpdatePage_spindindust__3Kgxy"};